import { Pagination } from './Pagination'

export class RoleCMSData {
  private id: number
  private roleName: string
  private menu: Menu[]
  private needSalesCode?: boolean
  private createdAt: string
  private updatedAt: string

  constructor(
    id: number,
    roleName: string,
    menu: Menu[],
    needSalesCode: boolean,
    createdAt: string,
    updatedAt: string
  ) {
    {
      ;(this.id = id),
        (this.roleName = roleName),
        (this.menu = menu),
        (this.needSalesCode = needSalesCode),
        (this.createdAt = createdAt),
        (this.updatedAt = updatedAt)
    }
  }
}

export class RoleCMSS {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: RoleCMSData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: RoleCMSData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}

export class Menu {
  public id: number
  public description: string
  public name: string
  public permissionId: string

  constructor(
    id: number,
    description: string,
    name: string,
    permissionId: string
  ) {
    this.id = id
    this.description = description
    this.name = name
    this.permissionId = permissionId
  }
}
